import React, { Component } from 'react'
import cloneDeep from 'lodash/cloneDeep'
import clone from 'lodash/clone'
import each from 'lodash/each'
import lodashGet from 'lodash/get'
import lodashSet from 'lodash/set'
import invoke from 'lodash/invoke'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import { buildFontFaceCss } from '~/Classes/fontFaceCss'
import Table from './Table'
import TableCanvasHolder from './Table/tableCanvasHolder'
import TableItemHolder from './Table/tableItemHolder'
import TableOnlyOptions from './Table/tableOnlyOptions'
import Tr from './Tr'
import Td from './Td'
import TdCanvasColumn from './Td/tdCanvasColumn'
import Div from './Div'
import DivItemHolder from './Div/divItemHolder'
import DivEditable from './Div/divEditable'
import DivColumnHolder from './Div/divColumnHolder'
import DivCanvas from './Div/divCanvas'
import A from './A'
import Img from './Img'
import Span from './Span'
import Tbody from './Tbody'
import Label from './Label'
import Input from './Input'
import TextArea from './Textarea'
import Button from './Button'
import Checkbox from './Checkbox'
import Select from './Select'
import SelectOption from './Select/option'
import Hr from './Hr'
import Poll from './Poll'
import moment from 'moment'
import axios from '~/data/http/axios'
import RssFeed from './RssFeed'
import Captcha from './Captcha'
import ButtonLink from './ButtonLink'
import GenericEditable from './Generic'
export default class Canvas extends Component {
    constructor(props) {
        super(props)

        this.state = {
            imagesReloading: {}
        }
        this.moveElement = this.moveElement.bind(this)
        this.insertElement = this.insertElement.bind(this)
        this.deleteElement = this.deleteElement.bind(this)
        this.copyElement = this.copyElement.bind(this)
        this.processElementExternalData = this.processElementExternalData.bind(this)
        this.addColumn = this.addColumn.bind(this)
        this.moveElementUp = this.moveElementUp.bind(this)
        this.moveElementDown = this.moveElementDown.bind(this)
        this.replacePropertyValue = this.replacePropertyValue.bind(this)
        this.updateElement = this.updateElement.bind(this)
        this.updateImage = this.updateImage.bind(this)
        this.checkForImageUpdates = this.checkForImageUpdates.bind(this)
        this.setFloatingToolbarWidth = this.setFloatingToolbarWidth.bind(this)
        this.clearDragCache = this.clearDragCache.bind(this)
        this.dragElementsData = null
    }

    clearDragCache() {
        this.dragElementsData = null
    }

    getDragElementsData() {
        return this.dragElementsData || this.props.elementsData
    }

    setFloatingToolbarWidth() {
        const templatBodyBuilderFloatingWysiToolbar = document.getElementById('templatBodyBuilderFloatingWysiToolbar')
        if (templatBodyBuilderFloatingWysiToolbar) {
            const leftNavEle = document.getElementsByClassName('dndEditorv2-leftTools')
            const leftToolsEle = document.getElementsByClassName('dndEditorv2-leftTools-holder')

            if (leftNavEle?.length > 0 && leftToolsEle?.length > 0) {
                //get remainign screen with
                let remainingWidth = window.innerWidth - leftNavEle[0].offsetWidth - leftToolsEle[0].offsetWidth - 15
                if (remainingWidth < 600) remainingWidth = 600 //Fixed so cant get smaller on 1000px screen
                templatBodyBuilderFloatingWysiToolbar.style.width = remainingWidth + 'px'
            }
        }
    }

    componentDidMount() {
        this.unmounting = false
        this.checkForImageUpdates()

        this.setFloatingToolbarWidth()

        window.addEventListener('resize', this.setFloatingToolbarWidth)
    }

    componentWillUnmount() {
        this.unmounting = true
        window.removeEventListener('resize', this.setFloatingToolbarWidth)
    }

    moveElement(currentElementPath, hoveredElementPath, insertingIntoParent) {
        var elementsData = cloneDeep(this.getDragElementsData())
        var movingElement = lodashGet(elementsData, currentElementPath)
        if (!movingElement) {
            // Stale path vs tree (common during rapid hover before React re-renders)
            return false
        }
        movingElement = cloneDeep(movingElement)
        var hoveredElement = cloneDeep(lodashGet(elementsData, hoveredElementPath))
        movingElement = this.replacePropertyValue('eleId', movingElement)

        var movingIndex = Number(
            currentElementPath.substring(currentElementPath.lastIndexOf('[')).replace('[', '').replace(']', '')
        )
        var targetIndex = Number(
            hoveredElementPath.substring(hoveredElementPath.lastIndexOf('[')).replace('[', '').replace(']', '')
        )

        var movingPathShort = currentElementPath.substring(0, currentElementPath.lastIndexOf('.')) + '.elements'
        var sourceArr = lodashGet(elementsData, movingPathShort)
        if (!Array.isArray(sourceArr) || movingIndex < 0 || movingIndex >= sourceArr.length) {
            return false
        }
        invoke(elementsData, movingPathShort + '.splice', movingIndex, 1)

        var finalElementPath = hoveredElementPath
        var targetPathShort = ''

        if (insertingIntoParent === true) {
            targetPathShort = hoveredElementPath + '.elements'
            var upOrDown = DragDropFunctions.movingUpDown(currentElementPath, hoveredElementPath)
            if (upOrDown === -1 && hoveredElement && hoveredElement.elements && hoveredElement.elements.length > 1) {
            } else {
                //its an empty element (ie a column)
                targetPathShort = hoveredElementPath + '.elements'
                invoke(elementsData, targetPathShort + '.push', movingElement)
                //set the current path to 0
                finalElementPath = hoveredElementPath + '.elements[0]'
            }
        } else {
            targetPathShort = hoveredElementPath.substring(0, hoveredElementPath.lastIndexOf('.')) + '.elements'
            invoke(elementsData, targetPathShort + '.splice', targetIndex, 0, movingElement)
        }

        this.dragElementsData = elementsData
        this.props.updateElementsData(elementsData, finalElementPath)
        return true
    }

    moveElementUp(elementPath) {
        var elementIndex = elementPath.substring(elementPath.lastIndexOf('[')).replace('[', '').replace(']', '')

        if (isNaN(elementIndex)) {
            return
        }
        elementIndex = Number(elementIndex)

        //only let them move up if not first element
        if (elementIndex > 0) {
            var elementsData = cloneDeep(this.props.elementsData)
            let elPathShort = elementPath.substring(0, elementPath.lastIndexOf('.')) + '.elements'
            const parentArray = lodashGet(elementsData, elPathShort)

            const a = cloneDeep(parentArray[elementIndex - 1])
            const b = cloneDeep(parentArray[elementIndex])

            const newArray = [...parentArray]
            newArray[elementIndex - 1] = b
            newArray[elementIndex] = a

            lodashSet(elementsData, elPathShort, newArray)
            const newElementPath =
                elementPath.substring(0, elementPath.lastIndexOf('[')) + '[' + (elementIndex - 1) + ']'

            this.props.updateElementsData(elementsData, newElementPath)
        }
    }

    moveElementDown(elementPath) {
        var elementIndex = elementPath.substring(elementPath.lastIndexOf('[')).replace('[', '').replace(']', '')

        if (isNaN(elementIndex)) {
            return
        }
        elementIndex = Number(elementIndex)
        var elementsData = cloneDeep(this.props.elementsData)
        let elPathShort = elementPath.substring(0, elementPath.lastIndexOf('.')) + '.elements'
        const parentArray = lodashGet(elementsData, elPathShort)
        //only let them move down if not last element
        if (elementIndex + 1 < parentArray.length) {
            const a = cloneDeep(parentArray[elementIndex + 1])
            const b = cloneDeep(parentArray[elementIndex])

            const newArray = [...parentArray]
            newArray[elementIndex + 1] = b
            newArray[elementIndex] = a

            lodashSet(elementsData, elPathShort, newArray)

            const newElementPath =
                elementPath.substring(0, elementPath.lastIndexOf('[')) + '[' + (elementIndex + 1) + ']'

            this.props.updateElementsData(elementsData, newElementPath)
        }
    }

    async processElementExternalData(elementPath, element, elementsDataSource) {
        const { landingPageId } = this.props
        if (!landingPageId || !element?.localVariables) return null

        try {
            const result = await DragDropFunctions.checkForExternalData(element.localVariables, {
                landingPageId
            })
            if (!result?.updated) return result

            const elementsData = cloneDeep(elementsDataSource || this.props.elementsData)
            if (!lodashGet(elementsData, elementPath)) return result
            lodashSet(elementsData, elementPath + '.localVariables', result.localVars)
            this.props.updateElementsData(elementsData, elementPath)
            return result
        } catch (e) {
            console.error('Failed to process element external data', e)
            return null
        }
    }

    insertElement(hoveredElementPath, currentElementContent, insertingIntoParent) {
        var copyContent = cloneDeep(currentElementContent)
        // A drop always begins from the committed tree, so read straight from props
        var elementsData = cloneDeep(this.props.elementsData)
        copyContent = this.replacePropertyValue('eleId', copyContent)
        // Refresh tuuids (root + any nested, eg blocks) so a new drop never reuses an existing
        // stage key. Mirrors copyElement. Ensure the root always has one for its React key.
        copyContent = this.replacePropertyValue('tuuid', copyContent)
        if (!copyContent.tuuid) copyContent.tuuid = DragDropFunctions.createGUID()
        var newElementPath = hoveredElementPath

        var elPathShort = ''
        if (!insertingIntoParent) {
            var newIndex =
                Number(
                    hoveredElementPath.substring(hoveredElementPath.lastIndexOf('[')).replace('[', '').replace(']', '')
                ) + 1
            newElementPath =
                hoveredElementPath.substring(0, hoveredElementPath.lastIndexOf('.')) + '.elements[' + newIndex + ']'
            elPathShort = hoveredElementPath.substring(0, hoveredElementPath.lastIndexOf('.')) + '.elements'
            invoke(elementsData, elPathShort + '.splice', newIndex, 0, copyContent)
        } else {
            elPathShort = hoveredElementPath
            invoke(elementsData, elPathShort + '.elements.push', copyContent)
            var hoveredElement = lodashGet(elementsData, hoveredElementPath)
            if (!hoveredElement.length) {
                newElementPath += '.elements[0]'
            }
        }

        this.dragElementsData = elementsData
        this.props.updateElementsData(elementsData, newElementPath)

        if (copyContent.localVariables) {
            const insertedElement = lodashGet(elementsData, newElementPath)
            this.processElementExternalData(newElementPath, insertedElement || copyContent, elementsData)
        }
    }

    copyElement(elementPath) {
        var elementsData = cloneDeep(this.props.elementsData)
        var copyEl = cloneDeep(lodashGet(elementsData, elementPath))
        copyEl = this.replacePropertyValue('eleId', copyEl)
        copyEl = this.replacePropertyValue('rssId', copyEl)
        copyEl = this.replacePropertyValue('tuuid', copyEl)

        if (copyEl.localVariables) {
            DragDropFunctions.resetLocalVariablesOnCopy(copyEl.localVariables)
        }

        var elPathShort = elementPath.substring(0, elementPath.lastIndexOf('.')) + '.elements'
        var elementIndex = elementPath.substring(elementPath.lastIndexOf('[')).replace('[', '').replace(']', '')
        invoke(elementsData, elPathShort + '.splice', elementIndex, 0, copyEl)
        var pathToNewElement = elementPath.substring(0, elementPath.lastIndexOf('[')) + '[' + elementIndex + ']'
        this.props.updateElementsData(elementsData, pathToNewElement, false, pathToNewElement)

        if (copyEl.localVariables) {
            this.processElementExternalData(pathToNewElement, copyEl, elementsData)
        }
    }

    deleteElement(elementPath) {
        var elementsData = cloneDeep(this.props.elementsData)
        var elPathShort = elementPath.substring(0, elementPath.lastIndexOf('.')) + '.elements'
        var elementIndex = elementPath.substring(elementPath.lastIndexOf('[')).replace('[', '').replace(']', '')
        invoke(elementsData, elPathShort + '.splice', elementIndex, 1)
        this.props.updateElementsData(elementsData, '')
    }

    addColumn(holderIndex) {
        var elementsData = cloneDeep(this.props.elementsData)
        var thisEl = cloneDeep(elementsData.elements[1].elements[holderIndex].elements[0].columns)
        var newCol = cloneDeep(thisEl[thisEl.length - 1])
        thisEl.splice(thisEl.length - 1, 0, newCol)

        //adjust widths of all cols - might wanna remove this later i dunno
        var colWidth = Math.round(100 / thisEl.length)

        thisEl.map((theEl, index) => {
            theEl.props.width.value = colWidth + '%'
            return theEl
        })

        thisEl = this.replacePropertyValue('eleId', thisEl)
        //add the new cols
        elementsData.elements[1].elements[holderIndex].elements[0].columns = thisEl

        this.props.updateElementsData(elementsData, holderIndex, null, null, null)
    }

    updateElement(newContent, targetPath, overRideFinalPath) {
        var finalPath = '.elements'
        var elementsData = cloneDeep(this.props.elementsData)
        var elPathShort = targetPath.substring(0, targetPath.lastIndexOf('.')) + finalPath
        if (overRideFinalPath) {
            if (overRideFinalPath == 'NONE') {
                elPathShort = targetPath
            } else {
                elPathShort = targetPath + overRideFinalPath
            }
        }
        var copyEl = cloneDeep(lodashGet(elementsData, elPathShort))
        // The node was just moved, so this path is stale. Writing it back builds
        // an `elements` object (not an array) and the colour walk unmounts the editor.
        if (copyEl === undefined) return
        if (!Array.isArray(copyEl)) {
            lodashSet(elementsData, elPathShort, newContent)
        } else {
            invoke(elementsData, elPathShort + '.splice', 0, 1, newContent)
        }
        this.props.updateElementsData(elementsData, null)
    }

    replacePropertyValue(searchKey, object) {
        const newObject = clone(object)
        each(object, (val, key) => {
            if (key === searchKey) {
                var newVal = ''
                newVal = Math.floor(Math.random() * 999999)

                newObject[key] = newVal
            } else if (typeof val === 'object' || typeof val === 'array') {
                newObject[key] = this.replacePropertyValue(searchKey, object[key])
            }
        })
        return newObject
    }

    updateImage(imageData) {
        var updateDate = moment().format()
        var queue = this.state.imagesReloading
        if (queue[imageData.tuuid]) return
        queue[imageData.tuuid] = {
            tuuid: imageData.tuuid,
            updateDate: updateDate,
            imageWidth: imageData.imageWidth,
            imageHeight: imageData.imageHeight,
            imageUri: imageData.imageUri
        }
        this.setState({ imagesReloading: queue })
    }

    checkForImageUpdates() {
        if (this.unmounting) return
        var self = this
        function findImageByTUUID(tuuid, elements, path) {
            var foundPath = ''
            if (elements && typeof elements == 'object') {
                Object.keys(elements).forEach((key) => {
                    if (Array.isArray(elements[key]) || typeof elements[key] == 'object') {
                        var tmpPath = path
                        if (Array.isArray(elements[key])) {
                            tmpPath += key + '['
                        } else {
                            tmpPath += key + '].'
                        }
                        foundPath += findImageByTUUID(tuuid, elements[key], tmpPath)
                    } else {
                        if (key === 'tuuid') {
                            if (elements[key] == tuuid) foundPath = path
                        }
                    }
                })
            }
            return foundPath
        }

        if (self.state.imagesReloading && Object.keys(self.state.imagesReloading).length) {
            var promises = []

            var imagesReloading = this.state.imagesReloading
            var foundUpdate = false
            Object.keys(imagesReloading).forEach((image) => {
                var thisImage = imagesReloading[image]
                if (moment().diff(thisImage.updateDate, 'seconds') >= 0) {
                    foundUpdate = true
                    promises.push(
                        axios
                            .post(`/template/resizeImage/${self.props.templateId}`, {
                                imageUri: thisImage.imageUri,
                                imageHeight: thisImage.imageHeight,
                                imageWidth: thisImage.imageWidth
                            })
                            .then((_res) => {
                                return { result: _res.data, thisImage, tuuid: image }
                            })
                            .catch((err) => {
                                return { result: false, thisImage, tuuid: image }
                            })
                    )
                }
            })
            if (foundUpdate) {
                Promise.all(promises).then((_response) => {
                    _response.forEach((_img) => {
                        delete imagesReloading[_img.tuuid]
                        if (_img && _img.result && _img.result.newFileUri) {
                            //get our local image

                            var imagePath = findImageByTUUID(_img.thisImage.tuuid, self.props.elementsData, '')
                            imagePath = imagePath.substr(0, imagePath.length - 1)
                            var ourData = lodashGet(self.props.elementsData, imagePath)
                            if (ourData && ourData.localVariables && ourData.localVariables.imageSrc) {
                                ourData.localVariables.imageSrc.value = _img.result.newFileUri
                            }
                            try {
                                ourData.elements[0].elements[0].elements[0].elements[0].elements[0].elements[0].elements[0].props.src.value =
                                    _img.result.newFileUri
                            } catch (err) {}
                            lodashSet(self.props.elementsData, imagePath, ourData)
                        }
                    })

                    self.props.updateElementsData(self.props.elementsData, null)

                    setTimeout(self.checkForImageUpdates, 500)
                })
            } else {
                setTimeout(self.checkForImageUpdates, 500)
            }
        } else {
            setTimeout(self.checkForImageUpdates, 500)
        }
    }

    render() {
        var propsToPass = {
            selectedElement: this.props.selectedElement,
            elementsData: this.props.elementsData,
            moveElement: this.moveElement,
            insertElement: this.insertElement,
            deleteElement: this.deleteElement,
            copyElement: this.copyElement,
            addColumn: this.addColumn,
            moveElementUp: this.moveElementUp,
            moveElementDown: this.moveElementDown,
            updateElement: this.updateElement,
            clickElement: this.props.clickElement,
            globalVariables: this.props.elementsData.globalVariables,
            saveFaveColor: this.props.saveFaveColor,
            currentParentPath: '',
            updateBlocks: this.props.updateBlocks,
            showGuideLines: this.props.showGuideLines,
            templateId: this.props.templateId,
            updateImage: this.updateImage,
            setDragging: this.props.setDragging,
            campaign: this.props.campaign,
            isLandingPage: this.props.isLandingPage,
            landingPageId: this.props.landingPageId,
            processElementExternalData: this.processElementExternalData,
            clearDragCache: this.clearDragCache
        }

        var thisStyle = this.props.elementsData.elements.find((item) => {
            return item.type === 'style'
        })
        if (thisStyle === undefined) {
            if (this.props.elementsData.elements[0].type === 'head') thisStyle = this.props.elementsData.elements[0]
        }

        var finalStyle = thisStyle
            ? DragDropFunctions.generateHtmlFromJson(
                  thisStyle,
                  true,
                  this.props.elementsData.globalVariables,
                  this.props.templateType === 'landingPage' ? null : '.templateBody',
                  null,
                  this.props.templateType !== 'landingPage' ? this.props.canvasScreenType == 1 : false,
                  this.props.templateType === 'landingPage'
              )
            : ''

        var self = this
        function parseHTML(theEl, currentPath, localVariables, tuuid) {
            if (theEl.renderOnly) return
            return theEl.elements.map((subEl, index) => {
                var theOut
                var tmpPath
                if (currentPath == '') {
                    tmpPath = currentPath + 'elements[' + index + ']'
                } else {
                    tmpPath = currentPath + '.elements[' + index + ']'
                }
                if (subEl && subEl.localVariables) {
                    localVariables = subEl.localVariables
                }

                if (subEl && subEl.tuuid) {
                    tuuid = { tuuid: subEl.tuuid }
                    if (subEl.imgTemp) tuuid.imgTemp = subEl.imgTemp
                }

                if (subEl && subEl.version) {
                    propsToPass.currentParentPath = tmpPath
                }

                if (subEl && subEl.enabled) {
                    //if we do have an enabled flag, just make sure its true or false. If false dont display the component
                    if (
                        subEl.enabled == false ||
                        subEl.enabled == '0' ||
                        subEl.enabled == '0%' ||
                        subEl.enabled == '0px'
                    )
                        return
                    if (subEl.enabled.indexOf('localVariables_') > 0) {
                        if (
                            localVariables[subEl.enabled.replace('_localVariables_.', '')].value == 'false' ||
                            localVariables[subEl.enabled.replace('_localVariables_.', '')].value == '0' ||
                            localVariables[subEl.enabled.replace('_localVariables_.', '')].value == '0%' ||
                            localVariables[subEl.enabled.replace('_localVariables_.', '')].value == '0px'
                        ) {
                            return
                        }
                    }
                }

                var imageReloading = false
                if (self.state.imagesReloading[tuuid.tuuid]) imageReloading = true

                var parentInlineFormContentDate = propsToPass.inlineFormContentDate
                if (subEl?.contentDate) {
                    propsToPass.inlineFormContentDate = subEl.contentDate
                }

                if (subEl && subEl.type) {
                    switch (subEl.type) {
                        case 'style':
                            if (subEl.dragDrop == 'customstyle') {
                                theOut = (
                                    <div
                                        key={'style_' + index}
                                        dangerouslySetInnerHTML={{
                                            __html: DragDropFunctions.generateHtmlFromJson(
                                                subEl,
                                                true,
                                                self.props.elementsData.globalVariables,
                                                null,
                                                localVariables
                                            )
                                        }}
                                    />
                                )
                                break
                            }
                        case 'table':
                            switch (subEl.dragDrop) {
                                case 'canvasHolder':
                                    theOut = (
                                        <TableCanvasHolder
                                            key={subEl.tuuid || 'tbl_' + index}
                                            elementData={subEl}
                                            path={tmpPath}
                                            localVariables={localVariables}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </TableCanvasHolder>
                                    )
                                    break
                                case 'itemHolder':
                                    theOut = (
                                        <TableItemHolder
                                            key={subEl.tuuid || 'tbl2_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            path={tmpPath}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </TableItemHolder>
                                    )
                                    break
                                case 'onlyOptions':
                                    //allows clicks for options but no dragging
                                    theOut = (
                                        <TableOnlyOptions
                                            key={subEl.tuuid || 'tbl_' + index}
                                            elementData={subEl}
                                            path={tmpPath}
                                            localVariables={localVariables}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </TableOnlyOptions>
                                    )
                                    break
                                default:
                                    theOut = (
                                        <Table
                                            key={subEl.tuuid || 'tbl3_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            path={tmpPath}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </Table>
                                    )
                            }

                            break

                        case 'tr':
                            theOut = (
                                <Tr
                                    key={subEl.tuuid || 'tr_' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                >
                                    {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                </Tr>
                            )
                            break

                        case 'tbody':
                            theOut = (
                                <Tbody
                                    key={subEl.tuuid || 'tbody_' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                >
                                    {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                </Tbody>
                            )
                            break
                        case 'td':
                            switch (subEl.dragDrop) {
                                case 'canvasColumn':
                                    theOut = (
                                        <TdCanvasColumn
                                            key={subEl.tuuid || 'td_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            tuuid={tuuid}
                                            path={tmpPath}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </TdCanvasColumn>
                                    )
                                    break
                                case 'itemHolder':
                                    theOut = (
                                        <DivItemHolder
                                            elementType='td'
                                            key={subEl.tuuid || 'div3_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            tuuid={tuuid}
                                            path={tmpPath}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </DivItemHolder>
                                    )
                                    break
                                default:
                                    theOut = (
                                        <Td
                                            key={subEl.tuuid || 'td2_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            path={tmpPath}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </Td>
                                    )
                            }
                            break

                        case 'nav':
                        case 'div':
                            switch (subEl.dragDrop) {
                                case 'canvasHolder':
                                    theOut = (
                                        <DivCanvas
                                            key={subEl.tuuid || 'div1_' + index}
                                            elementData={subEl}
                                            path={tmpPath}
                                            localVariables={localVariables}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </DivCanvas>
                                    )
                                    break
                                case 'itemHolder':
                                    theOut = (
                                        <DivItemHolder
                                            key={subEl.tuuid || 'div4_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            path={tmpPath}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </DivItemHolder>
                                    )
                                    break
                                case 'canvasColumn':
                                    theOut = (
                                        <DivColumnHolder
                                            key={subEl.tuuid || 'div3_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            path={tmpPath}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </DivColumnHolder>
                                    )
                                    break
                                default:
                                    theOut = (
                                        <Div
                                            key={subEl.tuuid || 'div2_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            path={tmpPath}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </Div>
                                    )
                            }

                            break

                        case 'a':
                            switch (subEl.dragDrop) {
                                case 'itemHolder':
                                    theOut = (
                                        <DivItemHolder
                                            elementType='a'
                                            key={subEl.tuuid || 'span_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            path={tmpPath}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </DivItemHolder>
                                    )
                                    break
                                default:
                                    theOut = (
                                        <A
                                            key={subEl.tuuid || 'a_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            path={tmpPath}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </A>
                                    )
                            }

                            break
                        case 'span':
                            switch (subEl.dragDrop) {
                                case 'itemHolder':
                                    theOut = (
                                        <DivItemHolder
                                            elementType='span'
                                            key={subEl.tuuid || 'span_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            path={tmpPath}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </DivItemHolder>
                                    )
                                    break
                                default:
                                    theOut = (
                                        <Span
                                            key={subEl.tuuid || 'span_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            path={tmpPath}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </Span>
                                    )
                            }
                            break
                        case 'img':
                            switch (subEl.dragDrop) {
                                case 'itemHolder':
                                    theOut = (
                                        <DivItemHolder
                                            elementType='span'
                                            key={subEl.tuuid || 'span_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            path={tmpPath}
                                            tuuid={tuuid}
                                            {...propsToPass}
                                        >
                                            <Img
                                                elementData={subEl}
                                                localVariables={localVariables}
                                                tuuid={tuuid}
                                                path={tmpPath}
                                                imageReloading={imageReloading}
                                                {...propsToPass}
                                            >
                                                {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                            </Img>
                                        </DivItemHolder>
                                    )
                                    break
                                default:
                                    theOut = (
                                        <Img
                                            key={subEl.tuuid || 'img_' + index}
                                            elementData={subEl}
                                            localVariables={localVariables}
                                            tuuid={tuuid}
                                            path={tmpPath}
                                            imageReloading={imageReloading}
                                            {...propsToPass}
                                        >
                                            {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                        </Img>
                                    )
                            }
                            break
                        case 'hr':
                            theOut = (
                                <Hr
                                    key={subEl.tuuid || 'hr' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                >
                                    {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                </Hr>
                            )
                            break
                        case 'label':
                            theOut = (
                                <Label
                                    key={subEl.tuuid || 'label' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                >
                                    {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                </Label>
                            )
                            break
                        case 'input':
                            theOut = (
                                <Input
                                    key={subEl.tuuid || 'input' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                >
                                    {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                </Input>
                            )
                            break
                        case 'textarea':
                            theOut = (
                                <TextArea
                                    key={subEl.tuuid || 'textarea' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                >
                                    {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                </TextArea>
                            )
                            break
                        case 'button':
                            theOut = (
                                <Button
                                    key={subEl.tuuid || 'input' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                >
                                    {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                </Button>
                            )
                            break
                        case 'buttonLink':
                            theOut = (
                                <ButtonLink
                                    key={subEl.tuuid || 'button' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                >
                                    {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                </ButtonLink>
                            )
                            break
                        case 'checkbox':
                            theOut = (
                                <Checkbox
                                    key={subEl.tuuid || 'checkbox' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                />
                            )
                            break
                        case 'select':
                            theOut = (
                                <Select
                                    key={subEl.tuuid || 'select' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                >
                                    {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                </Select>
                            )
                            break
                        case 'option':
                            theOut = (
                                <SelectOption
                                    key={subEl.tuuid || 'selectOption' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                />
                            )
                            break
                        case 'poll':
                            theOut = (
                                <Poll
                                    key={subEl.tuuid || 'poll' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                />
                            )
                            break
                        case 'rssFeed':
                            theOut = (
                                <RssFeed
                                    key={subEl.tuuid || 'rss' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                />
                            )
                            break
                        case 'captcha':
                            theOut = (
                                <Captcha
                                    key={subEl.tuuid || 'rss' + index}
                                    elementData={subEl}
                                    localVariables={localVariables}
                                    path={tmpPath}
                                    tuuid={tuuid}
                                    {...propsToPass}
                                />
                            )
                            break
                        default:
                            if (subEl.type.indexOf('_localVariables_.') >= 0) {
                                theOut = (
                                    <GenericEditable
                                        key={subEl.tuuid || index}
                                        elementData={subEl}
                                        localVariables={localVariables}
                                        path={tmpPath}
                                        tuuid={tuuid}
                                        {...propsToPass}
                                    >
                                        {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                    </GenericEditable>
                                )
                            } else {
                                theOut = (
                                    <div key={subEl.tuuid || index}>
                                        {subEl.elements && parseHTML(subEl, tmpPath, localVariables, tuuid)}
                                    </div>
                                )
                            }
                    }
                }
                propsToPass.inlineFormContentDate = parentInlineFormContentDate
                return theOut
            })
        }

        var theEls = []
        // var elToStart = this.props.elementsData.elements.length > 1 ? this.props.elementsData.elements[1] : this.props.elementsData
        // var pathToStart = this.props.elementsData.elements.length > 1 ? "elements[1]" : "elements[0]"

        var elToStart = this.props.elementsData

        var pathToStart = ''

        theEls = parseHTML(elToStart, pathToStart, {}, 0)

        let templateBodyInnerStyle = {
            margin: '0',
            maxWidth: '100%',
            width: '100%',
            border: 'none',
            overflow: 'visible'
        }

        let screenType = 'desktop'

        switch (this.props.canvasScreenType) {
            case 0:
                screenType = 'desktop'
                break
            case 1:
                screenType = 'mobile'
                break
            case 2:
                screenType = 'tablet'
                break
        }

        return (
            <>
                <div className='templatBodyBuilderFloatingWysiToolbar' id='templatBodyBuilderFloatingWysiToolbar'></div>
                <div
                    className='dragAndDropCanvas dndEditorv2-dragAndDropCanvas'
                    style={{ height: '100%' }}
                    data-template-type={this.props.templateType}
                >
                    <style type='text/css'>
                        {DragDropFunctions.fontArray
                            .filter((theFontStyle) => theFontStyle.src == 'google')
                            .map((theFont) => {
                                return `
                ${buildFontFaceCss(theFont)}
                `
                            })}
                    </style>
                    {this.props.templateType === 'landingPage' && (
                        <link
                            rel='stylesheet'
                            href='https://cdn1.ourmailsender.com/siteContent/landingPages/landingPage.css?cssv=2.11'
                        />
                    )}
                    <div dangerouslySetInnerHTML={{ __html: finalStyle }} />

                    <div className='templateBody' id='templateBodyHolder'>
                        <div style={templateBodyInnerStyle} data-screen={screenType}>
                            {theEls}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
